import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowUpIcon, MicIcon, SparklesIcon } from 'lucide-react';
import { atnaChips } from '../../data/loisirs';
import { InscriptionDialog } from './InscriptionDialog';
interface LoisirsAtnaProps {
  onChip: (chip: string) => void;
}
const PANEL_LAYOUT_ID = 'atna-recreation-panel';
export function LoisirsAtna({
  onChip
}: LoisirsAtnaProps) {
  const [value, setValue] = useState('');
  const [openedWith, setOpenedWith] = useState<string | null>(null);
  const open = (text: string) => {
    const trimmed = text.trim();
    if (!trimmed) return;
    setOpenedWith(trimmed);
    setValue('');
  };
  return <section aria-labelledby="atna-recreation-title" data-id="element-1541" data-mp="53wmwzth6w6p">
      <h2 id="atna-recreation-title" className="sr-only" data-id="element-1542" data-mp="52ljj13xzqg4">
        Search assisted by ATNA
      </h2>

      {openedWith !== null ? <div className="h-[66px]" aria-hidden="true" data-id="element-1543" data-mp="srxpzt7vxkeq" /> : <motion.div layoutId={PANEL_LAYOUT_ID} style={{
      borderRadius: 999
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-1544" data-mp="xlipxqt1gogk">
          <form onSubmit={event => {
        event.preventDefault();
        open(value);
      }} className="flex items-center gap-3 rounded-full border border-slate-200 bg-white py-2.5 pl-5 pr-2.5 shadow-lg shadow-ville-navy/5 transition-colors duration-150 ease-ville focus-within:border-ville-indigo" data-id="element-1545" data-mp="1phfb6vurbj0t">
            <SparklesIcon className="h-5 w-5 shrink-0 text-ville-indigo" aria-hidden="true" data-id="element-1546" data-mp="2d6q2znu4q32t" />
            <label htmlFor="atna-recreation" className="sr-only" data-id="element-1547" data-mp="2885c4f0rovr1">
              What are you looking for?
            </label>
            <input id="atna-recreation" type="text" value={value} onChange={event => setValue(event.target.value)} placeholder="Register my child, find an activity…" className="min-w-0 flex-1 border-0 bg-transparent py-2.5 text-base text-ville-navy placeholder:text-slate-400 focus:outline-none sm:text-lg" data-id="element-1548" data-mp="2n5fm1jxrhtkn" />
            <button type="button" aria-label="Dictate your search" className="grid h-10 w-10 shrink-0 place-items-center rounded-full text-slate-500 transition-colors duration-150 ease-ville hover:bg-slate-100 hover:text-ville-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1549" data-mp="nt3cyn808u1t">
              <MicIcon className="h-5 w-5" aria-hidden="true" data-id="element-1550" data-mp="1mg40918u5sl0" />
            </button>
            <button type="submit" aria-label="Send the search" className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-ville-lime text-ville-navy transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1551" data-mp="1rh01t85pt2n9">
              <ArrowUpIcon className="h-5 w-5" aria-hidden="true" data-id="element-1552" data-mp="25855clc7ef2v" />
            </button>
          </form>
        </motion.div>}

      <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-3" data-id="element-1553" data-mp="2a8aplgg58zax">
        <p className="text-xs font-semibold uppercase tracking-wider text-ville-indigo" data-id="element-1554" data-mp="2f7dxd8nidjml">Powered by ATNA</p>
        <ul className="-mx-5 flex snap-x gap-2.5 overflow-x-auto px-5 sm:mx-0 sm:flex-wrap sm:overflow-visible sm:px-0" data-id="element-1555" data-mp="2k2jgjzpj0k6z">
          <li className="shrink-0 snap-start" data-id="element-1556" data-mp="3i7degog19ar">
            <button type="button" onClick={() => open('Register my child')} className="rounded-full border border-ville-navy bg-ville-navy px-4 py-2 text-sm font-semibold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1557" data-mp="3hege7fady5t">
              Register my child
            </button>
          </li>
          {atnaChips.map(chip => <li key={chip} className="shrink-0 snap-start" data-id="element-1558" data-mp="mb1k6nbwxv3w">
              <button type="button" onClick={() => {
            if (chip === 'Find an activity') {
              open(chip);
              return;
            }
            setValue(chip);
            onChip(chip);
          }} className="rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1559" data-mp="hgntuzc3ye63">
                {chip}
              </button>
            </li>)}
        </ul>
      </div>

      <AnimatePresence data-id="element-1560" data-mp="ft6siuo89rek">
        {openedWith !== null && <InscriptionDialog key="atna-recreation-inscription" initialText={openedWith} layoutId={PANEL_LAYOUT_ID} onClose={() => setOpenedWith(null)} data-id="element-1561" data-mp="kpx7feoaqgye" />}
      </AnimatePresence>
    </section>;
}